import { APP_CONFIG } from '../../app.config';

export const RESET_CONFIG = {
  requests: {
    checkToken: {
      name: 'checkToken',
      url: `${APP_CONFIG.apiBaseUrl}/account/check-token`,
    },
    resetPassword: {
      name: 'resetPassword',
      url: `${APP_CONFIG.apiBaseUrl}/account/reset-password`,
    },
  },
};
